export const projects = [
  {
    title: "Onboarding App",
    description: "SPA onboarding app built with React and Tailwind.",
    imageSrc: "/images/onboarding.webp",
    githubLink: "https://github.com/ikorotkaya/buena-onboarding",
    websiteLink: "https://buena-onboarding.netlify.app/",
  },
  {
    title: "MILES Experiences",
    description:
      "Feature for a MILES Carsharing App. Estimate the costs and time needed for your trip to your chosen location.",
    imageSrc: "/images/miles.webp",
    githubLink: "https://github.com/ikorotkaya/miles_experiences",
    websiteLink: "https://miles-experiences.netlify.app/",
  },
  {
    title: "Hangman Game",
    description:
      "A digital adaptation of the classic word-guessing game. It currently supports two languages.",
    imageSrc: "/images/hangman.webp",
    githubLink: "https://github.com/ikorotkaya/hangman_typescript_react",
    websiteLink: "https://hangman-word-guessing-game.netlify.app/",
  },
  {
    title: "Hamburg Architecture",
    description: `Interactive map showing new buildings in Hamburg presented in the "Day of Architecture" event from 2014 onwards. The latest release features two languages (EN, DE).`,
    imageSrc: "/images/hamburg.webp",
    githubLink: "https://github.com/ikorotkaya/hamburg_architecture",
    websiteLink: "https://hamburg-architecture.netlify.app/",
  },
  {
    title: "Reddit Lite",
    description:
      "An application that allows users to view and search posts and comments sourced from the Reddit API. It includes lazy loading for endless scrolling through posts.",
    imageSrc: "/images/reddit.webp",
    githubLink: "https://github.com/ikorotkaya/reddit_lite",
    websiteLink: "https://reddit-app-lite.netlify.app/",
  },
  {
    title: "Create Playlist",
    description:
      "Link your Spotify to this app, utilize the Spotify API to search for music, craft your playlists, and securely store them in your Spotify account.",
    imageSrc: "/images/playlist.webp",
    githubLink: "https://github.com/ikorotkaya/create_playlist",
    websiteLink: "https://exotic-jelly.surge.sh/",
  },
  {
    title: "Currency Exchange Chart",
    description:
      "Explore the potential of Chart.js and make use of the fetch options to create and continuously update currency charts.",
    imageSrc: "/images/currency.webp",
    githubLink: "https://github.com/ikorotkaya/currency_exchange_chart",
    websiteLink: "https://ikorotkaya.github.io/currency_exchange_chart/",
  },
  {
    title: "Passing Thoughts",
    description:
      "A space for momentary musings. Add a concise thought, and watch it fade away in just 10 seconds.",
    imageSrc: "/images/thoughts.webp",
    githubLink: "https://github.com/ikorotkaya/passing_thoughts",
    websiteLink: "https://pass-thoughts.netlify.app/",
  },
];
